import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-contact-commerce-form',
  templateUrl: './contact-commerce-form.component.html',
  styleUrls: ['./contact-commerce-form.component.scss']
})
export class ContactCommerceFormComponent extends FormBaseComponent<any> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('same', new FormControl(false));
  }

  copiarContact(event)
  {
    if (this.form.value.same) {
      this.form.get('adminContact').patchValue(this.form.get('operativeContact').value);
    } else {
      this.form.get('adminContact').reset();
    }
  }

  get isSame(){
    return this.form.get('same').value;
  }


}



// WEBPACK FOOTER //
// ./src/app/form/form/contact-commerce-form/contact-commerce-form.component.ts